import { Component, OnDestroy, OnInit } from "@angular/core";
import { WorkflowService } from "../../workflow/workflow.service";
import { WsService } from "../../ws/ws.service";

export interface Script {
  childs?: Array<Element>;
  instruction?: string;
  script?: string;
  title?: string;
  readonly?: boolean;
  id?: number;
  queues: number[];
}

export interface Responce {
  id: number;
  queues: number[];
  script: Script;
}

export interface NewScript {
  readonly?: boolean;
  id?: number;
  queues?: Array<number>;
  script: Script;
  instruction?: string;
}

export interface Obs {
  script?: Script;
  id: number;
  queues: number[];
}

export interface Description {
  script?: string;
  instruction?: string;
}

export interface IClient {
  X5: number;
  cash_back_stand?: string | number;
  cash_back_stand_proc?: string | number;
  champ_name: string;
  couponName: string;
  date_event: string;
  dt_reg: string;
  fs?: number | string;
  i?: string;
  f: string;
  id_call_reason: number;
  id_mech: number;
  kupon_name: string;
  match_name: string;
  mech_cnt_days: number;
  mechanic: null;
  mechanicDuration: number;
  method: string;
  o?: string;
  state: number;
}

@Component({
  selector: "app-script",
  templateUrl: "./script.component.html",
  styleUrls: ["./script.component.scss"],
})
export class ScriptComponent implements OnInit, OnDestroy {
  public listOfScripts: Array<Script | NewScript>;
  public processingClient?: Description = undefined;
  public client: any = null;

  private scriptSub: any;
  private clientSub: any;

  constructor(public workflow: WorkflowService, private ws: WsService) {
    this.processingClient = {
      script: "",
      instruction: "",
    };
    this.listOfScripts = [];

    this.client = this.ws.getClient();
    if (this.client && this.client.id_call_reason) {
      this.onClient(this.client);
    }

    this.clientSub = this.ws.onClient.subscribe(this.onClient.bind(this));
  }

  private onClient(client: IClient): void {
    this.listOfScripts.length = 0;
    this.client = client;
    if (!this.scriptSub) {
      this.scriptSub = this.workflow.obs$.subscribe((r: any) => {
        this.onScriptLoaded(r);
      });
    }

    this.workflow.getScriptByReason(client.id_call_reason);
  }

  private onScriptLoaded(data: Responce): void {
    this.listOfScripts.push(data);
    this.listOfScripts.forEach((script: Script) => this.parseHtml(script));
  }

  public goIntoTreeNode(el: Script | NewScript): void {
    if (!el.readonly) {
      this.listOfScripts.push(el);
      this.parseHtml(el);
    } else {
      this.workflow.checkLoadedScripts(el.id);
    }
  }

  public goBack(): void {
    this.listOfScripts.pop();
    this.parseHtml(this.listOfScripts[this.listOfScripts.length - 1]);
  }

  public goHome(): void {
    this.listOfScripts.splice(1);
    this.parseHtml(this.listOfScripts[0]);
  }

  private parseHtml(script: Script | NewScript): void {
    let client = this.client;
    this.processingClient.script = "";
    this.processingClient.instruction = "";

    const replacer = (description: string) => {
      if (description) {
        description = description.replace(/\*\*([^*]+)\*\*/g, "<b>$1</b>");
        description = description.replace(/\_\_([^*]+)\_\_/g, "<i>$1</i>");
        description = description.replace(/\[I\]/g, client.i || " ");
        description = description.replace(/\[F\]/g, client.f || " ");
        description = description.replace(/\[ENTER\]/g, "<br>");
        description = description.replace(/\[O\]/g, client.o || " ");
        description = description.replace(/\[FS\]/g, client.fs || " 0 ");
        description = description.replace(
          /\[MATCHNAME\]/g,
          client.match_name || " (используй календарь событийности) "
        );
        description = description.replace(
          /\[CHAMPNAME\]/g,
          client.champ_name || " "
        );
        description = description.replace(
          /\[MATCHDATE\]/g,
          client.date_event || " "
        );
        description = description.replace(
          /\[CASHBACKPERCENT\]/g,
          client.cash_back_stand_proc || " 0 "
        );
        description = description.replace(/\[FT\]/g, client.ft || " нет ");
        description = description.replace(/\[FTSP\]/g, client.ftsp || " нет ");
        description = description.replace(/\[FTBB\]/g, client.ftbb || " 0 ");
        description = description.replace(
          /\[FTMN\]/g,
          client.ftmn || " (используй календарь событийности) "
        );
        description = description.replace(/\[FTDE\]/g, client.ftde || " ");
        description = description.replace(/\[LOY\]/g, client.loy || " 0 ");
      }
      return description;
    };
    if (
      script &&
      script.script &&
      typeof script.script === "string" &&
      script.script.length > 0
    )
      this.processingClient.script = replacer(script.script);
    if (
      script &&
      script.instruction &&
      typeof script.instruction === "string" &&
      script.instruction.length > 0
    )
      this.processingClient.instruction = replacer(script.instruction);
  }

  public saveLogs() {
    console.log(
      "[",
      new Date(Date.now()),
      "]",
      "reason: ",
      this.client.id_call_reason
    );
    console.log(this.workflow.listOfScripts);
    this.workflow.listOfScripts.forEach((i: any) =>
      console.log(i.id, i.queues[0])
    );
  }

  ngOnInit() {}

  ngOnDestroy(): void {
    this.clientSub?.unsubscribe();
    this.scriptSub?.unsubscribe();
    if (this.client) this.client = null;
  }
}



// WEBPACK FOOTER //
// ./src/app/call/script/script.component.ts